import { render, staticRenderFns } from "./MemberLevelSettingStep2Goods.vue?vue&type=template&id=cf1e12c8&"
import script from "./MemberLevelSettingStep2Goods.vue?vue&type=script&lang=js&"
export * from "./MemberLevelSettingStep2Goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports